import { api, useApi } from '@gik/core/api';

export async function getInvitationEmailAddressFromToken(token: string): Promise<{ email: string }> {
  const response = api.get(`invitations/${token}`, {
    searchParams: {
      fields: 'email',
    },
  });

  return await response.json();
}

export function useInvitationEmailAddressFromToken(token: string) {
  return useApi<{ email: string }>(token ? `invitations/${token}` : null);
}

export async function acceptInvitation(routeId: string, invitationToken: string): Promise<void> {
  await api.post(`inkinds/${routeId}/organizers/${invitationToken}/confirm`);
}
